var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('funding-project-base',{attrs:{"state":_vm.state}},[_c('div',{staticClass:"container mt-8"},_vm._l((_vm.state.team),function(partner,index){return _c('team-section',{key:partner.id,class:{
        'mb-24': index + 1 !== _vm.state.team.length
      },attrs:{"type":partner.type,"partner-id":partner.id,"company":partner.company,"team":partner.users,"staff":partner.staff,"is-admin":true}})}),1)])}
var staticRenderFns = []

export { render, staticRenderFns }